import moment from 'moment'

const convertToRangedDateLocalTime = (type, date) => {
  // Set the time of the 'to' date to be 23:59:59
  // so the range also incudes data from this day
  // This function expects and returns local times

  if (type === 'to') {
    return moment(date)
      .endOf('day')
      .toDate()
  }

  return date
}

export default convertToRangedDateLocalTime
